import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, viewChild } from '@angular/core';
import { DataApiContext } from '@app/common/services/data-api/data-api-context';
import { DataApi } from '@app/common/services/data-api/data-api.service';
import { PlexEnvironment } from '@app/env';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { DialogActionsComponent, DialogComponent } from '@progress/kendo-angular-dialog';
import { GridComponent, GridModule } from '@progress/kendo-angular-grid';
import { IEnvironment } from 'environments/ienvironment';
import { Subscription } from 'rxjs';
import { ErrorService } from '../../../common/services/error.service';
import { AppVersion, DatabaseVersion, RootObject, VersionTable } from './default-version-model';

@Component({
  selector: 'app-default-version',
  templateUrl: './default-version.component.html',
  styleUrls: ['./default-version.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AsyncPipe,
    ButtonDirective,
    DialogActionsComponent,
    DialogComponent,
    GridModule,
  ],
})
export class DefaultVersionComponent implements OnInit {
  private api = inject(DataApi);
  public error = inject(ErrorService);
  public env: IEnvironment = inject(PlexEnvironment);

  public service: DataApiContext<RootObject>;
  public apiVersionInfo: AppVersion;
  public databaseVersion: DatabaseVersion;
  public dialogOpened: boolean = false;
  public info: VersionTable[] = [];
  public maxWidth: number;
  public maxHeight: number;
  private errorSubscription: Subscription;

  readonly gridProperties = viewChild(GridComponent);
  readonly gridErrors = viewChild(GridComponent);

  constructor() {
    this.service = this.api.getApiService<RootObject>('versions', null);
    this.error.showErrorsEvent.subscribe(() => {
      this.openDialog();
    })
  }

  public closeDialog() {
    this.dialogOpened = false;
  }

  public openDialog() {
    this.dialogOpened = true;
  }

  public clearErrors() {
    this.error.clearErrors();
  }

  public ngOnInit() {
    this.maxWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    this.maxHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    this.errorSubscription = this.error.messageStore.subscribe(s => {
      const gridErrors = this.gridErrors();
      if (s && s.length && gridErrors) {
        gridErrors.autoFitColumns();
        this.errorSubscription.unsubscribe();
      }
    });

    let env = this.env;
    VersionTable.addOne('App Build', env?.buildDate?.toString() ?? '');
    this.info = VersionTable.table;

    this.service.query(false).then(s => {
      if (s && s.length) {
        let root = s[0];
        this.apiVersionInfo = root.AppVersion;
        this.databaseVersion = root.DatabaseVersion;

        VersionTable.addOne('API Version', this.apiVersionInfo.Version);
        VersionTable.addOne('API Build', this.apiVersionInfo.BuildDate.toString());
        VersionTable.addOne('API Env', this.apiVersionInfo.Environment);
        VersionTable.addOne('DB Context', this.databaseVersion.Catalog + '.' + this.databaseVersion.DatabaseSource);
        VersionTable.addOne('DB Last Mod', this.databaseVersion.DatabaseLastModifiedSchemaView && this.databaseVersion.DatabaseLastModifiedSchemaView.LastModified.toString());
        VersionTable.addOne('DB Item Last', this.databaseVersion.DatabaseLastModifiedSchemaView && this.databaseVersion.DatabaseLastModifiedSchemaView.LastItemModified);

        this.info = VersionTable.table;
        const gridProperties = this.gridProperties();
        if (gridProperties) {
          gridProperties.autoFitColumns();
        }
      }
    });
  }
}